import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NvTooltipModule } from 'Src/ng2/shared/nv-tooltip/nv-tooltip.module';
import { MatIconModule } from '@angular/material/icon';
import { MatDividerModule } from '@angular/material/divider';
import { MatSelectModule } from '@angular/material/select';
import { RegentsExamSupportsTable } from './regents-exam-supports-table.component';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

@NgModule({
  imports: [
    CommonModule,
    MatSelectModule,
    MatDividerModule,
    MatIconModule,
    NvTooltipModule,
    FormsModule,
    ReactiveFormsModule,
    MatMenuModule,
    MatButtonModule,
  ],
  declarations: [RegentsExamSupportsTable],
  exports: [RegentsExamSupportsTable],
})
export class RegentsExamSupportsTableModule {
  //
}
